import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import gql from 'graphql-tag';
export const getTasksDocumentsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetTasksDocuments($id: Int) {\n    taskDocuments(id: $id) {\n      id\n      filename\n      createdAt\n      createdBy\n    }\n  }\n"])));
export const getTasksDocumentsQueryOptions = id => ({
  variables: {
    id
  },
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true
});
export const getAllTasksDocumentsQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query GetAllTasksDocuments {\n    allTaskDocuments {\n      id\n      filename\n      createdAt\n      createdBy\n      taskID\n    }\n  }\n"])));